function formatDataTableIndexing(table_id) {
	// Indexing below table
	if (!table_id.includes('#')) {
		$(table_id).each(function() {
			table = $(this).closest('.dataTables_wrapper').attr('id').replace('_wrapper', '');
			paginateAndSearchArrange(`#${table}`);
		});
	} else {
		paginateAndSearchArrange(table_id);
	}
}

function paginateAndSearchArrange(table_id) {
	var searchRow 		= $(`${table_id}_wrapper > div:nth-child(1)`);
	var paginationRow 	= $(`${table_id}_wrapper > div:nth-child(3)`);
	$(searchRow).find('.columns').removeClass('small-6 columns');
	$(searchRow).removeClass('row').addClass('d-flex justify-content-between flex-row-reverse');
	$(paginationRow).find('.columns').removeClass('small-6 columns');
	$(paginationRow).removeClass('row').addClass('d-flex justify-content-between');
}

window.formatDataTableIndexing = formatDataTableIndexing;